<template>
  <WtFullPageLoader />
</template>

<script>
import WtFullPageLoader from "@@/WtFullPageLoader/WtFullPageLoader.vue";

export default {
  name: "MobileRedirect",
  components: {
    WtFullPageLoader
  },
  async mounted() {
    const mobileJwt = this.$route.params.mobileToken;
    const destination = this.$route.params.page;
    const destinationId = this.$route.params.pageId;

    if (mobileJwt === null || destination === null) {
      alert("Invalid Request.");
    }

    this.$auth.token("auth_token_default", mobileJwt, false);

    switch (destination) {
      case "challenges":
        await this.$router.push({
          name: "Challenge",
          params: { challengeId: destinationId }
        });
        break;
      case "teams":
        await this.$router.push({
          name: "Team",
          params: { teamId: destinationId }
        });
        break;
      case "challenge-builder": {
        const isAdmin = this.$auth.user()?.isAdmin;

        if (isAdmin) {
          await this.$router.push({
            name: "ChallengeBuilder"
          });
        } else {
          await this.$router.push({
            name: "MemberChallengeBuilder",
            params: { mode: "create" }
          });
        }
        break;
      }
      case "organization":
        await this.$router.push({
          name: "ChooseOrganization"
        });
        break;
      case "points":
        await this.$router.push({
          name: "Points"
        });
        break;
      case "badges":
        await this.$router.push({
          name: "BadgesPage"
        });
        break;
      case "unanswered-member-questions":
        await this.$router.push({
          name: "MemberQuestions"
        });
        break;
      default:
        alert("Invalid Request.");
        break;
    }
  }
};
</script>
